import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ViewSubmissions.css';
import './shared.css';
import { useAuth } from '../context/AuthContext';
import config from '../config';

function ViewSubmissions({ onBack }) {
  const [entries, setEntries] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useAuth();

  useEffect(() => {
    loadEntries();
  }, []);

  const loadEntries = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${config.API_BASE_URL}/entries`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const nonEmptyEntries = response.data.filter(entry => 
        entry.celebrities && entry.celebrities.length > 0
      );
      setEntries(nonEmptyEntries);
    } catch (error) {
      setError('Error loading entries');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="view-submissions">
      <div className="menu-bar">
        <button className="menu-button" onClick={onBack}>Back to Home</button>
        {selectedEntry && (
          <button className="menu-button" onClick={() => setSelectedEntry(null)}>Back to List</button>
        )}
      </div>
      <h2>All Death Pool Lists</h2>
      {!selectedEntry && (
        <p className="helper-text">Click a person to see their list</p>
      )}
      {isLoading ? (
        <div className="loading-message">Loading lists...</div>
      ) : (
        selectedEntry ? (
          <div className="selected-celebrities">
            <h3>{selectedEntry.playerName}'s List</h3>
            <ul>
              {selectedEntry.celebrities.map((celeb, index) => (
                <li key={index}>
                  <div className="celeb-number">#{index + 1}</div>
                  <div className="celeb-name">{celeb.label}</div>
                  {celeb.description && (
                    <div className="celeb-description">{celeb.description}</div>
                  )}
                  <div className="wiki-link">
                    {celeb.wikipediaUrl ? (
                      <a href={celeb.wikipediaUrl} target="_blank" rel="noopener noreferrer">
                        View Wikipedia Page →
                      </a>
                    ) : (
                      <span className="no-wiki">No Wikipedia page available</span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="entries-list">
            {entries.map((entry, index) => (
              <div key={index} className="entry-item" onClick={() => setSelectedEntry(entry)}>
                <h3>{entry.playerName}</h3>
                <div className="entry-details">
                  <p className="entry-status">
                    {entry.celebrities.length}/10 Celebrities Selected
                  </p>
                </div>
              </div>
            ))}
            {!isLoading && entries.length === 0 && <p>No lists created yet</p>}
          </div>
        )
      )}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default ViewSubmissions; 